<template>
<div class="chapter">
<div class="inner_page">
<p class="BOD1">Contents</p>
<h2 class="TOC-FBMHD"><a href="#/int#int">Introduction</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c01#c01">How to use this book</a></h2>
<h2 class="TOCCT"><a href="#/c01#c01a">The Building Blocks</a></h2>
<p class="TOC-AHD"><span href="#/c03#sec1" title="Link target outside of Sample">Appliquéd Circle</span></p>
<p class="TOC-AHD"><span href="#/c04#sec2" title="Link target outside of Sample">Basket Weave</span></p>
<p class="TOC-AHD"><span href="#/c05#sec3" title="Link target outside of Sample">Chain-Pieced strips</span></p>
<p class="TOC-AHD"><span href="#/c06#sec4" title="Link target outside of Sample">Chevrons</span></p>
<p class="TOC-AHD"><span href="#/c07#sec5" title="Link target outside of Sample">Crazy Triangles</span></p>
<p class="TOC-AHD"><span href="#/c08#sec6" title="Link target outside of Sample">Cross Block</span></p>
<p class="TOC-AHD"><span href="#/c09#sec7" title="Link target outside of Sample">Half-Square Triangles</span></p>
<p class="TOC-AHD"><span href="#/c10#sec8" title="Link target outside of Sample">Log Cabin</span></p>
<p class="TOC-AHD"><span href="#/c11#sec9" title="Link target outside of Sample">Pieced Squares</span></p>
<p class="TOC-AHD"><span href="#/c12#sec10" title="Link target outside of Sample">Portholes</span></p>
<p class="TOC-AHD"><span href="#/c13#sec11" title="Link target outside of Sample">Quarter Circles</span></p>
<p class="TOC-AHD"><span href="#/c14#sec12" title="Link target outside of Sample">String Block</span></p>
<p class="TOC-AHD"><span href="#/c15#sec13" title="Link target outside of Sample">X Block</span></p>
<h2 class="TOCCT"><span href="#/c16#c16" title="Link target outside of Sample">The Quilts</span></h2>
<p class="TOC-AHD"><span href="#/c17#c17" title="Link target outside of Sample">Shoe Boxes Quilt</span></p>
<p class="TOC-AHD"><span href="#/c20#c20" title="Link target outside of Sample">Farm Buildings Quilt</span></p>
<p class="TOC-AHD"><span href="#/c23#c23" title="Link target outside of Sample">Seed Tray Quilt</span></p>
<p class="TOC-AHD"><span href="#/c26#c26" title="Link target outside of Sample">Feathers Quilt</span></p>
<p class="TOC-AHD"><span href="#/c29#c29" title="Link target outside of Sample">Bricks and Fences Quilt</span></p>
<p class="TOC-AHD"><span href="#/c32#c32" title="Link target outside of Sample">Garden Wall Quilt</span></p>
<p class="TOC-AHD"><span href="#/c35#c35" title="Link target outside of Sample">Mesh Quilt</span></p>
<p class="TOC-AHD"><span href="#/c38#c38" title="Link target outside of Sample">Pavement Quilt</span></p>
<p class="TOC-AHD"><span href="#/c41#c41" title="Link target outside of Sample">Plates Quilt</span></p>
<p class="TOC-AHD"><span href="#/c44#c44" title="Link target outside of Sample">Railings Quilt</span></p>
<p class="TOC-AHD"><span href="#/c47#c47" title="Link target outside of Sample">Rope Quilt</span></p>
<p class="TOC-AHD"><span href="#/c50#c50" title="Link target outside of Sample">Building Blocks Quilt</span></p>
<h2 class="TOC-FBMHD"><span href="#/c52#c52" title="Link target outside of Sample">General Techniques</span></h2>
<h2 class="TOC-FBMHD"><span href="#/sup#sup" title="Link target outside of Sample">Suppliers</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ack#ack" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ack#ata" title="Link target outside of Sample">About the Author</span></h2>
<h2 class="TOC-FBMHD"><span href="#/cop#cop" title="Link target outside of Sample">Copyright</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?654c42be